const toasts = (state) => state.toasts;

export const activeToast = (state) => toasts(state).activeToast;
export const isToastActive = (state) => !!activeToast(state);
